import type { ReactNode } from 'react';

export const BarringGroup = ({ id, children }: { id?: string; children: ReactNode[] }) => {
  return (
    <div id={id} className="of-barrings-content__group">
      {children}
    </div>
  );
};
